import { Dropdown, Avatar } from 'antd';
import type { MenuProps } from 'antd';
import { useAuthStore } from '../../../stores/authStore';
import { useTranslation } from 'react-i18next';

/**
 * UserProfile component displays current user information and logout option
 * Typically used in header/navbar
 */

const UserProfile = () => {
  const { t } = useTranslation();
  const user = useAuthStore(state => state.user);
  const logout = useAuthStore(state => state.logout);

  if (!user) return null;

  // Map role to display text
  const roleDisplay = {
    admin: t('auth.role.admin', '管理员'),
    editor: t('auth.role.editor', '编辑者'),
    viewer: t('auth.role.viewer', '访客'),
  };

  const menuItems: MenuProps['items'] = [
    {
      key: 'info',
      label: (
        <div className="px-1 py-1 text-xs text-content-muted cursor-default">
          {roleDisplay[user.role as keyof typeof roleDisplay]} · {user.email}
        </div>
      ),
      disabled: true,
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      label: t('auth.logout', '退出登录'),
      onClick: logout,
    },
  ];

  return (
    <Dropdown
      menu={{ items: menuItems }}
      trigger={['click']}
      placement="bottomRight"
      overlayClassName="user-profile-dropdown"
      overlayStyle={{ minWidth: 192 }}
    >
      <button className="flex max-w-xs items-center rounded-full bg-transparent text-sm focus:outline-none focus:ring-2 focus:ring-fashion-green focus:ring-offset-2 focus:ring-offset-page-base">
        <span className="sr-only">Open user menu</span>
        <div className="flex items-center">
          <Avatar
            size={32}
            src={user.avatar}
            style={{
              background: '#13c2c2',
              boxShadow: '0 0 10px rgba(19,194,194,0.3)',
              color: '#fff',
              fontWeight: 'bold',
              fontSize: '14px',
            }}
          >
            {user.username.charAt(0).toUpperCase()}
          </Avatar>
          <span className="ml-3 block text-sm font-medium text-content-primary hover:text-content-primary transition-colors">
            {user.username}
          </span>
        </div>
      </button>
    </Dropdown>
  );
};

export default UserProfile;
